<div class="section">
  <h3 class="title">
    <b>
      {{
        isDelivery
          ? 'Lieferanschrift bearbeiten'
          : 'Rechnungsanschrift bearbeiten'
      }}
    </b>
  </h3>
  <div class="container">
    <app-text-field
      label="Name der Einrichtung"
      appearance="outline"
      [inputProps]="{
        maxlength: '70'
      }"
      [inputControl]="formGroup.controls.customerName"
      [errorMessages]="{
        required: 'errors.required' | translate
      }" />
    <app-text-field
      label="Name der Einrichtung Zusatz"
      appearance="outline"
      [inputProps]="{
        maxlength: '70'
      }"
      [inputControl]="formGroup.controls.customerName2"
      [errorMessages]="{
        required: 'errors.required' | translate
      }" />
    <div style="display: flex; gap: 16px">
      <app-text-field
        label="Straße"
        appearance="outline"
        [inputProps]="{
          maxlength: '27'
        }"
        [inputControl]="formGroup.controls.street"
        [errorMessages]="{
          required: 'errors.required' | translate
        }"
        style="flex: 1" />
      <app-text-field
        style="width: 100px"
        label="Nr"
        appearance="outline"
        [inputProps]="{
          maxlength: '8'
        }"
        [inputControl]="formGroup.controls.houseNo"
        [errorMessages]="{
          required: 'errors.required' | translate
        }" />
    </div>
    <div style="display: flex; gap: 16px">
      <app-text-field
        style="width: 100px"
        label="PLZ"
        appearance="outline"
        [inputProps]="{
          maxlength: '5'
        }"
        [inputControl]="formGroup.controls.postalCode"
        [errorMessages]="{
          required: 'errors.required' | translate
        }" />
      <app-text-field
        style="flex: 1"
        label="Stadt"
        appearance="outline"
        [inputControl]="formGroup.controls.city"
        [errorMessages]="{
          required: 'errors.required' | translate
        }" />
    </div>
  </div>
</div>
